module.exports = __webpack_public_path__ + "img/horse_create_tiers.b091c944.png";